import Button from './index';
import { register, action } from 'react-easy-styleguide';

register(
  Button,
  `In west Philadelphia born and raised
  On the playground where I spent most of my time
  Chilling out, maxing, relaxing all cool

  And all shooting some b-ball outside of the school
  When a couple of guys who were up to no good
  Started making trouble in my neighborhood
  I got in one little fight and my mom got scared
  And said you’re moving with your auntie and uncle in Bel Air`,
  [
    {
      name: 'Default',
      props: {
        label: 'I am a button'
      }
    },
    {
      name: 'Success',
      props: {
        label: 'Great Success',
        type: 'success'
      }
    },
    {
      name: 'Large',
      props: {
        label: 'Great Success',
        size: 'lg',
        type: 'primary'
      }
    }
  ],
  {
    onClick: action('You clicked a button')
  }
)
